const QuoteCartPage = () => {
    const main = document.getElementById('quote-cart');
    if (!main) {
        return;
    }
    const billingPrefix = '#billing-';
    const shippingPrefix = '#shipping-';

    const element = {
        billing: {
            id: $(`${billingPrefix}id`),
            existingAddress: $(`${billingPrefix}address`),
            country: $(`${billingPrefix}country`),
            city: $(`${billingPrefix}city`),
            state: $(`${billingPrefix}state`),
            streetAddress: $(`${billingPrefix}street_address`),
            zip: $(`${billingPrefix}zip`),
        },
        shipping: {
            id: $(`${shippingPrefix}id`),
            existingAddress: $(`${shippingPrefix}address`),
            country: $(`${shippingPrefix}country`),
            city: $(`${shippingPrefix}city`),
            state: $(`${shippingPrefix}state`),
            streetAddress: $(`${shippingPrefix}street_address`),
            zip: $(`${shippingPrefix}zip`),
        },
        billingDifferentAddress: $('#billing-different-address'),
        formAddressContent: $('#form-address-content'),
        formAddress: $('#form-address'),
        requestShippingQuote: $('#request-shipping-quote'),
    };

    const findAddresses = (id, addressType) => {
        axios.get(`/addresses/${id}`)
            .then((response) => {
                const { data } = response;

                element[addressType].country.val(data.country);
                element[addressType].country.trigger('change');
                element[addressType].city.val(data.city);
                element[addressType].state.val(data.state);
                element[addressType].streetAddress.val(data.street_address);
                element[addressType].zip.val(data.zip);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const clearAddressInputs = (addressType) => {
        element[addressType].country.val('GB');
        element[addressType].country.trigger('change');
        element[addressType].city.val('');
        element[addressType].state.val('');
        element[addressType].streetAddress.val('');
        element[addressType].zip.val('');
    };

    element.billing.existingAddress.change(function () {
        const value = parseInt($(this).val());

        element.billing.id.val(!value ? '' : value);

        if (!isNaN(value)) {
            findAddresses(value, 'billing');
        } else  {
            clearAddressInputs('billing');
        }
    });

    element.shipping.existingAddress.change(function () {
        const value = parseInt($(this).val());

        element.shipping.id.val(!value ? '' : value);

        if (!isNaN(value)) {
            findAddresses(value, 'shipping');
        } else {
            clearAddressInputs('shipping');
        }
    });

    element.billingDifferentAddress.change(function (e) {
        const isChecked = e.target.checked;

        if (isChecked) {
            element.billingDifferentAddress.val("1");
            element.formAddress.show();
        } else {
            element.billingDifferentAddress.val("");
            element.formAddress.hide();
        }
    });

    element.requestShippingQuote.change(function (e) {
        const isChecked = e.target.checked;

        if (isChecked) {
            element.requestShippingQuote.val("1");
            element.formAddressContent.show();
        } else {
            element.requestShippingQuote.val("");
            element.formAddressContent.hide();
        }
    });
};

$(() => {
    QuoteCartPage();
});
